import React from 'react'
import { RadixCheckbox, FormItem, FormLabel, FormControl } from '~/components'
import { cn } from '~/lib/utils'
import { CheckCircleIcon } from '@heroicons/react/20/solid'

export type StyledCheckboxProps = {
  label: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  className?: string
  id?: string
  description?: string
}

export const StyledCheckbox = ({
  label,
  checked,
  onCheckedChange,
  className,
  id,
  description,
}: StyledCheckboxProps) => {
  const checkboxId = id || `checkbox-${label.toLowerCase().replace(/\s+/g, '-')}`

  return (
    <FormItem className="flex flex-col space-y-0 h-full">
      <FormControl className="peer">
        <RadixCheckbox.Checkbox
          checked={checked}
          onCheckedChange={onCheckedChange}
          id={checkboxId}
          aria-describedby={`${checkboxId}-label`}
          className="absolute opacity-0 w-0 h-0 pointer-events-none"
        />
      </FormControl>
      <FormLabel
        htmlFor={checkboxId}
        id={`${checkboxId}-label`}
        className={cn(
          'flex flex-col w-full min-h-full text-sm md:items-center md:justify-center rounded-lg p-4 bg-slate-50 font-medium shadow-sm relative border-2 border-slate-200 text-slate-700 text-center transition-all duration-300 ease-in-out md:hover:bg-slate-100 md:hover:border-slate-300 md:hover:text-slate-800 cursor-pointer focus-within-ring-brand',
          checked &&
            'border-blue-300 bg-blue-100/60 text-slate-800 md:hover:text-slate-800 md:hover:bg-blue-100/80 md:hover:border-blue-400 transition-all duration-300 ease-in-out',
          'peer-focus-ring-brand',
          className
        )}
      >
        <span className="whitespace-normal break-words text-center">{label}</span>
        {description && (
          <span className="whitespace-normal break-words text-center text-xs text-slate-500 mt-1 font-normal">
            {description}
          </span>
        )}
        {checked && (
          <CheckCircleIcon className="absolute top-2 right-2 h-4 w-4 text-slate-600 animate-in fade-in-0 zoom-in-50 duration-200" />
        )}
      </FormLabel>
    </FormItem>
  )
}
